import axiosInstance from '../utils/axiosInstance';
import { showAlert } from '../components/common/toastify/ToastContainer';
import { ConfirmAlert } from '../components';
import { handleApiError } from '@/lib/handleApiError';

export const getOffers = async () => {
  try {
    const res = await axiosInstance.get('/SmartProAPI/api/offers');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const createOffer = async (offerData) => {
  try {
    const res = await axiosInstance.post('/SmartProAPI/api/offers', offerData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    showAlert('success', 'Offer created successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const updateOffer = async (offerId, offerData) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/offers/${offerId}`,
      offerData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Offer updated successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const deleteOffer = async (offerId) => {
  const result = await ConfirmAlert({
    confirmBtnText: 'Confirm Delete',
  });

  if (!result.isConfirmed) {
    handleApiError('error', 'Confirmation cancelled', error?.response?.status);
    throw new Error('Confirmation cancelled');
  }

  try {
    await axiosInstance.delete(`/SmartProAPI/api/offers/${offerId}`);
    showAlert('success', 'Offer deleted successfully');
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};
